module.exports = __webpack_public_path__ + "media/img/naked-logo-dd899ec71eaec004445690676c0f8474.png";